'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buckyQueryData = exports.submitPath = undefined;
exports.concatBuckyLabel = concatBuckyLabel;
exports.createPayload = createPayload;

var _enviro = require('enviro');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var envPrefix = (0, _enviro.getShort)();
var urlSuffix = envPrefix === 'qa' ? 'qa' : '';

var submitPath = exports.submitPath = 'https://app.hubspot' + urlSuffix + '.com/bucky/v2/send';
var buckyQueryData = exports.buckyQueryData = {
  monitoringType: 'js-library'
};

function concatBuckyLabel() {
  for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  if (!parts.length) {
    return 'jslib';
  }
  return parts.join('.');
}

function createPayload(product, location) {
  var labelPrefix = concatBuckyLabel(product, location, (0, _enviro.getShort)());

  // signal fx syntax - simply keeps track of overall errors.
  var payload = _defineProperty({}, labelPrefix + '.caughtErrors', '1|c');

  return payload;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/reliability/monitoringHelpers.js
// module id = 499
// module chunks = 3 4 5